import common from '../common';
import dateHelper from '../helpers/dateHelper';
import { HTTP_METHODS, HTTP_RESPONSE } from '../enums/http';
import { STORE } from '../enums/store';
import { SERVICE_BASIC } from '../enums/serviceBasicTypes';
//import arrayHelper from '../helpers/arrayHelper';

export default class JobService {
    constructor(utils) {
        this.utils = utils;
    }
    formatServiceHistory(item) {
        const job_types = this.utils.$store.state[STORE.SERVICE_SCHEDULE_LOOKUP].job_types;
        const job_categories = this.utils.$store.state[STORE.SERVICE_SCHEDULE_LOOKUP].jtc_categories;
        return {
            ...item,
            date_raised: dateHelper.formatDateReverse(item.date_raised),
            date_completed: dateHelper.formatDateReverse(item.date_completed),
            job_type: job_types.find(y => y.id === item.job_type_id)?.job_type,
            job_category: job_categories.find(y => y.id === item.lookup_job_category_id)?.category,
            loading: false,
            documents_loaded: false,
            documents_path: [],
            recharge: !!item.recharge,
            warranty: !!item.warranty,
            mark_up: item.mark_up || "0.00",
            warranty_text: item.warranty ? 'Yes' : 'No',
            supplier_name: item.supplier_name?.supp_name,
            defect: item.defect,
            defect_trimmed: item.defect?.length > 15 ? item.defect.substr(0, 15) + "\u2026" : item.defect,
            show_more: item.defect?.length > 15,
            comments_count: item.comments_count || 0,
        }
    }
    async getJobTrackers(per_page, status, vor = false) {
        let url = `/api/getTracker/${per_page}`;
        vor && (url += "?vor=1");
        status && (url += `?status=${status}`);
        let response = await common.loadAllResults({
            url,
            utils: this.utils
        });
        const suppliers = this.utils.$store.state[STORE.APP].suppliers;
        const job_statuses = this.utils.$store.state[STORE.JOBTRACKER].job_statuses;
        const work_progress_status_list = this.utils.$store.state[STORE.JOBTRACKER_LOOKUP].work_progress_status_list;
        let resp = response.map(y => ({
            ...y,
            status_disp: job_statuses.find(x => x.id == y.lookup_job_status_id)?.status,
            disp_work_progress_status: work_progress_status_list.find(x => x.id == y.lookup_work_progress_id)?.name,
            job_tracker_id: y.id,
            registration_number: y.vehicle_details?.registration_number,
            job_tracker_po_no: y.po_no,
            document_id: y.document_id,
            job_tracker_po_no_display: y.po_no && process.env.VUE_APP_JOBTRACKER_PO_NO_PREFIX + y.po_no,
            job_tracker_mileage: y.mileage || 0,
            date_raised: dateHelper.formatDateReverse(y.date_raised),
            date_completed: dateHelper.formatDateReverse(y.date_completed),
            date_of_completion: dateHelper.formatDateReverse(y.date_of_completion),
            supplier_id: y.supplier_id,
            supplier_name: y.supplier_id ? suppliers.find(x => x.id === y.supplier_id)?.supp_name : "",
            job_tracker_next_due_date: dateHelper.formatDateTimeReverse(y.next_due_date),
            past_due: y.next_due_date ? dateHelper.dateDifference(y.next_due_date, dateHelper.calenderFormatedDateTime(dateHelper.getTodaysDateTime())) >= 0 : false,
            servicehistory: y.servicehistory?.map(x => ({
                ...this.formatServiceHistory(x)
            })),
            comments_count: y.comments_count || 0,
        }));
        return resp;
    }
    async getJobTrackersWithPagination({
        itemsPerPage,
        utils,
        currentPage,
        headerFilters,
        sortBy,
        sortDesc
    }) {
        this.utils = utils;
        const is_incident = this.utils.$store.state[STORE.JOBTRACKER].is_incident;
        let queryParams = `page=${currentPage}`;

        if (is_incident) {
            queryParams += `&vor=1`;
            // default incident sorting
            if (!sortBy) {
                queryParams += `&sort_by=next_due_date&sort_dir=asc`;
            }
        }

        if (headerFilters) {
            for (let key in headerFilters) {
                if (headerFilters[key]) {
                    queryParams += `&${key}=${encodeURIComponent(headerFilters[key])}`;
                }
            }
        }
        if (sortBy) {
            queryParams += `&sort_by=${sortBy}&sort_dir=${sortDesc}`;
        }

        let response = await common.loadWithPagination({
            url: `/api/v2/getTracker/${itemsPerPage}?${queryParams}`,
            utils
        });

        const job_statuses = this.utils.$store.state[STORE.JOBTRACKER].job_statuses;
        let resp = response.data.data.map(y => ({
            ...y,
            lookup_job_status_id: y.lookup_job_status_id || job_statuses.find(x => x.status === y.status)?.id,
            disp_work_progress_status: y.work_progress,
            job_tracker_id: y.id,
            registration_number: y.registration_number,
            job_tracker_po_no: y.po_no,
            document_id: y.document_id,
            job_tracker_po_no_display: y.po_no && process.env.VUE_APP_JOBTRACKER_PO_NO_PREFIX + y.po_no,
            job_tracker_mileage: y.mileage || 0,
            date_raised: dateHelper.formatDateReverse(y.date_raised),
            date_completed: dateHelper.formatDateReverse(y.date_completed),
            date_of_completion: dateHelper.formatDateReverse(y.date_of_completion),
            supplier_id: y.supplier_id,
            supplier_name: y.supplier_name,
            driver_name: y.driver_name,
            driver_contact: y.driver_contact,
            job_tracker_next_due_date: dateHelper.formatDateTimeReverse(y.next_due_date),
            past_due: is_incident && y.next_due_date ? dateHelper.dateDifference(y.next_due_date, dateHelper.calenderFormatedDateTime(dateHelper.getTodaysDateTime())) >= 0 : false,
            comments_count: y.comments_count || 0,
            // servicehistory: y.servicehistory?.map(x => ({
            //     ...this.formatServiceHistory(x)
            // }))
        }));
        return {
            data: resp,
            totalPage: response.data.meta.total
        };
    }
    async getJobStatuses() {
        let response = await common.getRequest({
            url: `/api/getJobStatus`,
            utils: this.utils
        });
        if (response.status === HTTP_RESPONSE.SUCCESS) {
            return response.data;
        } else {
            return [];
        }
    }
    async getJobTracker(id) {
        let response = await common.getRequest({
            url: `/api/getJobTracker/${id}`,
            utils: this.utils
        });
        if (response.status === HTTP_RESPONSE.SUCCESS) {
            let data = Array.isArray(response.data) ? response.data[0] : response.data;
            if (!data) return null;
            return {
                ...data,
                vor: !!data.vor,
                next_due_date: dateHelper.formatDateTimeReverse(data.next_due_date),
                date_raised: dateHelper.formatDateReverse(data.date_raised),
                date_completed: dateHelper.formatDateReverse(data.date_completed),
                date_of_completion: dateHelper.formatDateReverse(data.date_of_completion),
            };
        } else {
            return null;
        }
    }
    async getJobs(job_id) {
        let response = await common.getRequest({
            url: `/api/getServiceTracker/${job_id}`,
            utils: this.utils
        });
        if (response.status === HTTP_RESPONSE.SUCCESS) {
            let job = response.data?.data?.find(x => x.job_id == job_id);
            return job ? job.servicehistory?.map(x => ({
                ...this.formatServiceHistory(x)
            })) : [];
        } else {
            return [];
        }
    }
    async getPendingServiceSchedule(filterValue) {
        let url = `/api/getPendingServiceSchedule`;
        filterValue && (url += `?filterValue=${filterValue}`);
        let response = await common.getRequest({
            url,
            utils: this.utils
        });
        const suppliers = this.utils.$store.state[STORE.APP].suppliers;
        const customers = this.utils.$store.state[STORE.APP].customers;
        const job_types = this.utils.$store.state[STORE.SERVICE_SCHEDULE_LOOKUP].job_types;
        const locations = this.utils.$store.state[STORE.LOCATION_LOOKUP].locations
        if (response.status === HTTP_RESPONSE.SUCCESS) {
            return response.data?.data?.map(y => {
                let supplier_name = y.supplier_id ? suppliers.find(x => x.id === y.supplier_id)?.supp_name : "";
                let customer_id = y.customer_id;
                let customer = customer_id ? customers.find(x => x.id === customer_id) : "";
                let next_due = y.v_service_basic === SERVICE_BASIC.MILES ? y.v_service_next_due_mile : dateHelper.formatDateReverse(y.v_service_next_due);
                let location = y.lookup_location_id ? locations.find(x => x.id === y.lookup_location_id) : "";
                let expired = false;
                if (y.v_service_basic === SERVICE_BASIC.MILES) {
                    expired = Number.parseInt(y.v_service_next_due_mile || 0) < Number.parseInt(y.mileage || 0);
                } else {
                    expired = (dateHelper.dateDifference(y.v_service_next_due, new Date()) > 0 ? true : false);
                }
                return {
                    ...y,
                    job_type: job_types.find(x => x.id === y.job_type_id)?.job_type,
                    supplier_name,
                    next_due,
                    location: location?.location_disp || "",
                    customer_name: customer?.cust_name || "",
                    expired
                }
            }) || [];
        } else {
            return [];
        }
    }
    async getServiceScheduleReport(params) {

        const page =
            params.currentPage || params.page || 1;

        const pageSize =
            params.itemsPerPage || params.page_size || 20;

        const sortBy =
            params.sortBy || params.sort_by;

        const sortDir =
            params.sortDesc || params.sort_dir || 'asc';

        const headerFilters =
            params.headerFilters || {};

        const fromDate =
            headerFilters.from_date ||
            dateHelper.formatDate(
                params.date_of_creation_from
            );

        const toDate =
            headerFilters.to_date ||
            dateHelper.formatDate(
                params.date_of_creation_to
            );

        let url =
            `/api/reports/service-schedule?page=${page}&page_size=${pageSize}`;

        if (fromDate && toDate) {

            url +=
                `&from_date=${fromDate}&to_date=${toDate}`;
        }


        Object.keys(headerFilters).forEach(key => {

            if (
                headerFilters[key] !== undefined &&
                headerFilters[key] !== null &&
                headerFilters[key] !== ''
            ) {

                url +=
                    `&${key}=${encodeURIComponent(headerFilters[key])}`;
            }
        });

        if (params.registration_number) {

            url +=
                `&registration_number=${encodeURIComponent(
                    params.registration_number
                )}`;
        }


        if (params.customer) {

            url +=
                `&customer_id=${params.customer}`;
        }


        if (sortBy) {

            url +=
                `&sort_by=${sortBy}&sort_dir=${sortDir}`;
        }


        if (params.include_mileage !== undefined) {

            url +=
                `&include_mileage=${params.include_mileage}`;
        }

        let response = await common.getRequest({

            url,

            utils: this.utils

        });

        const customers =
            this.utils.$store.state[STORE.APP].customers;

        const locations =
            this.utils.$store.state[STORE.LOCATION_LOOKUP]
                ? this.utils.$store.state[STORE.LOCATION_LOOKUP].locations
                : [];

        if (response.status === HTTP_RESPONSE.SUCCESS) {

            let apiData =
                response.data.data.data || [];

            let mappedData = apiData.map(y => {

                let supplier_name =
                    y.supplier?.supp_name || "";


                let customer_id =
                    y.vehicle?.contract?.length > 0
                        ? y.vehicle.contract[0]?.customer_id
                        : "";

                let customer =
                    customer_id
                        ? customers.find(
                            x => x.id === customer_id
                        )
                        : "";


                let mileage =
                    y.vehicle?.mileage?.mileage || 0;


                let location =
                    y.vehicle?.lookup_location_id
                        ? locations.find(
                            x => x.id === y.vehicle.lookup_location_id
                        )
                        : "";

                let next_due_mile =
                    y.v_service_basic === SERVICE_BASIC.MILES
                        ? y.v_service_next_due_mile
                        : "";

                let next_due_date =
                    y.v_service_basic === SERVICE_BASIC.MILES
                        ? ""
                        : dateHelper.formatDateReverse(
                            y.v_service_next_due
                        );

                let expired = false;

                if (
                    y.v_service_basic === SERVICE_BASIC.MILES
                ) {

                    expired =
                        Number.parseInt(
                            y.v_service_next_due_mile || 0
                        ) <
                        Number.parseInt(
                            mileage || 0
                        );

                } else {

                    expired =
                        (
                            dateHelper.dateDifference(
                                y.v_service_next_due,
                                new Date()
                            ) > 0
                        );
                }

                return {

                    ...y,

                    registration_number:
                        y.vehicle?.registration_number || "",

                    mileage,

                    supplier_name,

                    customer_name:
                        customer?.cust_name || "",

                    location:
                        location?.location_disp || "",

                    job_type:
                        y.service_job_type?.job_type || "",

                    next_due_mile,

                    next_due_date,

                    expired
                };
            });

            return {

                data: mappedData,

                totalPage:
                    response.data.data.total || 0
            };

        } else {

            return {

                data: [],

                totalPage: 0
            };
        }
    }
    async getServiceScheduleReport_old(params) {
        const page = params.page || 1;
        const pageSize = params.page_size || 20;

        const fromDate = dateHelper.formatDate(params.date_of_creation_from);
        const toDate = dateHelper.formatDate(params.date_of_creation_to);

        let url = `/api/reports/service-schedule?page=${page}&page_size=${pageSize}`;

        // 📅 Date filter
        if (fromDate && toDate) {
            url += `&from_date=${fromDate}&to_date=${toDate}`;
        }

        // 🔍 Filters
        if (params.registration_number) {
            url += `&registration_number=${encodeURIComponent(params.registration_number)}`;
        }

        if (params.customer) {
            url += `&customer_id=${params.customer}`;
        }

        // 🔃 Sorting (from AG Grid)
        if (params.sort_by) {
            url += `&sort_by=${params.sort_by}&sort_dir=${params.sort_dir || 'asc'}`;
        }
        // ✅ Include Mileage Boolean
        // handles true/false safely
        if (params.include_mileage !== undefined) {
            url += `&include_mileage=${params.include_mileage}`;
        }

        let response = await common.getRequest({
            url,
            utils: this.utils
        });

        const suppliers = this.utils.$store.state[STORE.APP].suppliers;
        const customers = this.utils.$store.state[STORE.APP].customers;
        const job_types = this.utils.$store.state[STORE.SERVICE_SCHEDULE_LOOKUP] ? this.utils.$store.state[STORE.SERVICE_SCHEDULE_LOOKUP].job_types : [];
        const locations = this.utils.$store.state[STORE.LOCATION_LOOKUP] ? this.utils.$store.state[STORE.LOCATION_LOOKUP].locations : [];

        if (response.status === HTTP_RESPONSE.SUCCESS) {
            let mappedData = response.data.data.map(y => {
                let supplier_name = y.supplier_id ? suppliers.find(x => x.id === y.supplier_id)?.supp_name : "";
                let customer_id = y.customer_id;
                let customer = customer_id ? customers.find(x => x.id === customer_id) : "";
                // let next_due = y.v_service_basic === SERVICE_BASIC.MILES ? y.v_service_next_due_mile : dateHelper.formatDateReverse(y.v_service_next_due);
                let next_due_mile = y.v_service_basic === SERVICE_BASIC.MILES ? y.v_service_next_due_mile : "";
                let next_due_date = y.v_service_basic === SERVICE_BASIC.MILES ? "" : dateHelper.formatDateReverse(y.v_service_next_due);
                let location = y.lookup_location_id ? locations.find(x => x.id === y.lookup_location_id) : "";
                let expired = false;
                if (y.v_service_basic === SERVICE_BASIC.MILES) {
                    expired = Number.parseInt(y.v_service_next_due_mile || 0) < Number.parseInt(y.mileage || 0);
                } else {
                    expired = (dateHelper.dateDifference(y.v_service_next_due, new Date()) > 0 ? true : false);
                }
                return {
                    ...y,
                    job_type: job_types.find(x => x.id === y.job_type_id)?.job_type,
                    supplier_name,
                    next_due_mile,
                    next_due_date,
                    location: location?.location_disp || "",
                    customer_name: customer?.cust_name || "",
                    expired
                }
            });

            return {
                data: mappedData,
                totalPage: response.data.total || response.data.meta?.total || 0
            };
        } else {
            return { data: [], totalPage: 0 };
        }
    }

    async getComments(job_id) {
        let response = await common.getRequest({
            url: `/api/getComment/${job_id}`,
            utils: this.utils
        });
        if (response.status === HTTP_RESPONSE.SUCCESS) {
            return response.data?.map(x => ({
                id: x.id,
                time: dateHelper.jsDateTimeFormatter(new Date(x.created_at)),
                user: x.user?.name || 'Unknown',
                email: x.user?.email || 'No Email',
                text: x.comment,
            })) || [];
        } else {
            return [];
        }
    }
    async getServiceHistory(vehicle_id, status = null) {
        let response = await common.getRequest({
            url: status ? `/api/getServiceTracker/${vehicle_id}/${status}` : `/api/getServiceTracker/${vehicle_id}`,
            utils: this.utils
        });
        if (response.status === HTTP_RESPONSE.SUCCESS) {
            return response.data.data.map(y => ({
                ...y,
                date_completed: dateHelper.formatDateReverse(y.date_completed),
                customer_name: y.customer_name || "",
                location: y.location || "",
                date_raised: dateHelper.formatDateReverse(y.date_raised),
                supplier_name: y.supplier_name || "",
                last_service_mileage: y.mileage || 0,
                current_miles: y.vehicle_details?.current_miles || 0,
                registration_number: y.vehicle_details?.registration_number,
                job_tracker_mileage: y.mileage || 0,
                job_tracker_next_due_date: dateHelper.formatDateTimeReverse(y.next_due_date),
                job_tracker_po_no_display: y.po_no && process.env.VUE_APP_JOBTRACKER_PO_NO_PREFIX + y.po_no,
                work_progress: y.work_progress,
                
                items: y.servicehistory.map(x => ({
                    ...this.formatServiceHistory(x)
                }))
            }));
        } else {
            return [];
        }
    }
    async getJobId() {
        let response = await common.getRequest({
            url: `/api/getJobId`,
            utils: this.utils
        });
        if (response.status === HTTP_RESPONSE.SUCCESS) {
            return response.data;
        } else {
            return null;
        }
    }
    async getjobCountsByStatus() {
        let response = await common.getRequest({
            url: `/api/getjobCountsByStatus`,
            utils: this.utils
        });
        if (response.status === HTTP_RESPONSE.SUCCESS) {
            return response.data;
        } else {
            return [];
        }
    }
    async saveJobTracker(inputs, method = HTTP_METHODS.POST) {
        let payload = {
            job_id: inputs.job_id,
            lookup_job_status_id: inputs.lookup_job_status_id,
            vehicle_id: inputs.vehicle_id,
            vor: inputs.vor,
            po_no: inputs.po_no,
            lookup_work_progress_id: inputs.lookup_work_progress_id,
            mileage: inputs.mileage,
            supplier_id: inputs.supplier_id,
            document_id: inputs.document_id,
            next_due_date: inputs.vor ? dateHelper.formatDateTime(inputs.next_due_date) : null,
            date_raised: inputs.date_raised ? dateHelper.formatDateTime(inputs.date_raised) : null,
            date_completed: inputs.date_completed ? dateHelper.formatDateTime(inputs.date_completed) : null,
            driver_name: inputs.driver_name,
            driver_contact: inputs.driver_contact,
            vehicle_location: inputs.vehicle_location,
            date_of_completion: inputs.date_of_completion ? dateHelper.formatDateTime(inputs.date_of_completion) : null,
            object: {
                vehicle_id: inputs.vehicle_id,
                vehicle_service_schedule_id: inputs.vehicle_service_schedule_id ? [...inputs.vehicle_service_schedule_id] : [],
                mileage: inputs.mileage,
                lookup_job_status_id: inputs.lookup_job_status_id,
                next_due_date: inputs.vor ? dateHelper.formatDateTime(inputs.next_due_date) : null,
                job_type_id: inputs.job_type_id,
                date_completed: inputs.date_completed ? dateHelper.formatDateTime(inputs.date_completed) : null
            }
        };
        if (method === HTTP_METHODS.POST) {
            payload.last_recorded_miles = inputs.last_recorded_miles;
        }
        return await common.saveRequest({
            method,
            url: method === HTTP_METHODS.POST ? `/api/addJobTracker` : `/api/updateJobTracker/${inputs.id}`,
            payload,
            utils: this.utils
        });
    }
    async saveComment({ job_tracker_id, comment }) {
        let payload = {
            job_tracker_id,
            comment,
        };
        return await common.saveRequest({
            method: HTTP_METHODS.POST,
            url: `/api/saveComment`,
            payload,
            utils: this.utils
        });
    }
    async addJobTrackerItem({ item, vehicle_id, job_id, job_trackers_id }) {
        let payload = {
            jobs: [
                {
                    vehicle_id,
                    job_id,
                    job_type_id: item.job_type_id,
                    mileage: item.mileage,
                    part_cost: item.part_cost,
                    labour_cost: item.labour_cost,
                    total_cost: isNaN(item.total_cost) ? null : item.total_cost,
                    mark_up: item.mark_up,
                    parts_recharge: item.parts_recharge,
                    labour_recharge: item.labour_recharge,
                    total_recharge: isNaN(item.total_recharge) ? null : item.total_recharge,
                    po_no: item.po_no,
                    lookup_job_category_id: item.lookup_job_category_id,
                    service_item: (item.service_item && item.service_item.length) ? item.service_item.map(y => y.id) : null,
                    driver_name: item.driver_name,
                    driver_contact: item.driver_contact,
                    defect: item.repiar_details,
                    vehicle_service_schedule_id: item.vehicle_service_schedule_id,
                    repiar_details: item.repiar_details,
                    warranty: item.warranty,
                    recharge: item.recharge,
                    vehicle_location: item.vehicle_location,
                    document_id: item.document_id,
                    status: process.env.VUE_APP_DEFAULT_JOB_STATUS
                }
            ]
        };
        return await common.saveRequest({
            method: HTTP_METHODS.POST,
            url: `/api/saveServiceHistory/${job_trackers_id}`,
            payload,
            utils: this.utils
        });

    }
    async updateJobTrackerItem(job) {
        let payload = {
            vehicle_id: job.vehicle_id,
            job_type_id: job.job_type_id,
            mileage: job.mileage,
            part_cost: job.part_cost,
            labour_cost: job.labour_cost,
            total_cost: isNaN(job.total_cost) ? null : job.total_cost,
            parts_recharge: job.parts_recharge,
            mark_up: job.mark_up,
            labour_recharge: job.labour_recharge,
            total_recharge: isNaN(job.total_recharge) ? null : job.total_recharge,
            po_no: job.po_no,
            lookup_job_category_id: job.lookup_job_category_id,
            service_item: (job.service_item && job.service_item.length) ? job.service_item.map(y => y.id) : null,
            driver_name: job.driver_name,
            driver_contact: job.driver_contact,
            defect: job.defect,
            repiar_details: job.repiar_details,
            warranty: job.warranty,
            recharge: job.recharge,
            document_id: job.document_id,
            vehicle_location: job.vehicle_location,
        };
        return await common.saveRequest({
            method: HTTP_METHODS.PUT,
            url: `/api/updateServiceHistory/${job.id}`,
            payload,
            utils: this.utils
        });
    }
    async saveWorkProgressAudit(payload) {
        return await common.saveRequest({
            method: HTTP_METHODS.POST,
            url: `/api/saveWorkProgressAudit`,
            payload,
            utils: this.utils
        });
    }
    async deleteJobTracker(id, suppress_error = false, reason = null) {
        let payload = {
            delete_reason: reason
        };
        return await common.deleteRequest({
            url: `/api/deleteJobTracker/${id}`,
            utils: this.utils,
            suppress_error,
            payload
        });
    }
    async deleteJobTrackerItem(id) {
        return await common.deleteRequest({
            url: `/api/removeServiceHistory/${id}`,
            utils: this.utils
        });
    }
}